import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  cell: {
    padding: '10px 9px',
    '& .align-center': {
      textAlign: 'center',
    },
    '& .align-right': {
      textAlign: 'right',
      paddingRight: '1em',
    },
    '&.featured': {
      fontWeight: 'bold',
      color: '#13174f',
    },
    '&.table-cell-has-expandedRowRender': {
      backgroundColor: `var(--gameday-table-orderItemDetailTableBg, ${theme.table.orderItemDetailTableBg})`,
    },
    '&.noBorderCell': {
      borderBottom: 0,
      padding: 0,
    },
    '&:not(.isGroupChild)': {
      borderBottom: `1px solid ${`var(--gameday-table-tableBorderColor, ${theme.table.tableBorderColor})`}`,
    },
    '&:has(.row-action)': {
      // biome-ignore lint/suspicious/noDuplicateObjectKeys: TODO
      position: '-webkit-sticky',
      position: 'sticky',
      right: 0,
      backgroundColor: `${`var(--gameday-mainNav-sidebarBgColor, ${theme.mainNav.sidebarBgColor})`}`,
      boxShadow: `-1px 1px 5px 0px ${`var(--gameday-mainNav-toggleColor, ${theme.mainNav.toggleColor})`}`,
    },
  },
})

const TableCell = ({ classNameDrag, header, data, getValue, classes, rowKey, noBorderCell, className }) => (
  <td className={cn({ featured: header.isFeatured, noBorderCell }, classes.cell, classNameDrag, className)}>
    <span className="cell-data">{getValue(data, header, rowKey)}</span>
  </td>
)

TableCell.defaultProps = {
  getValue: (data, header) => data[header.name],
  header: {},
  noBorderCell: false,
}

export default withStyles(styles)(TableCell)
